module.exports = __webpack_public_path__ + "static/lemondaydreamermain-64f79020547ffe09e7a84084e3e66eae.jpeg";